import { render, staticRenderFns } from "./DialogoDeCarrinhoDaVitrineVirtual.vue?vue&type=template&id=2ef89577&scoped=true&"
import script from "./DialogoDeCarrinhoDaVitrineVirtual.vue?vue&type=script&lang=ts&"
export * from "./DialogoDeCarrinhoDaVitrineVirtual.vue?vue&type=script&lang=ts&"
import style0 from "./DialogoDeCarrinhoDaVitrineVirtual.vue?vue&type=style&index=0&id=2ef89577&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef89577",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardText,VDialog,VDivider,VIcon,VProgressCircular,VSpacer,VToolbar,VToolbarTitle})
